/* eslint-disable no-useless-escape, no-control-regex, no-param-reassign */
export class MessageContent {
  private URL_REGEX = /((http(s)?|ftp):\/\/(?:(www\.)(www\.)+\S+|\S+[\.]+\S+)|(www\.)+\S+[\.]+\S+)([a-zA-Z\d])/gi;

  private ESCAPE_CHARS: { [key: string]: string } = {
    '<': '&lt;',
    '>': '&gt;',
  };

  private text: string;

  constructor(text: string) {
    this.text = text;
  }

  public EscapeHtml(): MessageContent {
    this.text = this.text.replace(/[<>]/g, (tag: string) => this.ESCAPE_CHARS[tag] || tag);
    return this;
  }

  public NewLinesToBreaks(): MessageContent {
    this.text = this.text.replace(new RegExp('\n', 'g'), '<br>');
    return this;
  }

  public ProcessUrls(): MessageContent {
    this.text = this.processUrls(this.text);
    return this;
  }

  public get Value(): string {
    return this.text;
  }

  private processUrls(rawMessage: string) {
    let html = rawMessage;

    const urls = rawMessage.match(this.URL_REGEX);
    if (urls) {
      urls.forEach((url) => {
        const cleanUrl = this.cleanupUrl(url);
        const urlAsLink = `<a href="${cleanUrl}" target="_blank" style="color: inherit">${cleanUrl}</a>`;
        html = html.replace(new RegExp(this.escapeRegExp(url)), urlAsLink);
      });
    }

    return html;
  }

  private cleanupUrl(url: string) {
    if (url.substr(0, 3) === 'www') {
      url = `http://${url}`;
    }
    return url;
  }

  private escapeRegExp(input: string) {
    return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
